<template>
  <div>
    <div class="d-md-flex align-center justify-space-between">
      <h1 class="mb-0 mr-3">Domains </h1>
      <v-btn
          v-if="user[0].can('edit_domains_budget')"
          @click="domainsBudgetImport = !domainsBudgetImport"
          color="primary"
      >
        <v-icon class="mr-2">mdi-upload</v-icon>
        Upload CSV
      </v-btn>
      <v-spacer></v-spacer>
      <div>
        <v-btn v-if="this.getDomainHistory.length !== 0"
               color="primary"
               class="btn-inner"
               style="margin: 5px"
               @click="this.saveBudget">
          Save Changes
        </v-btn>
        <v-btn
            v-if="this.selected.length !== 0 && (user[0].can('edit_domains_budget'))"
            color="primary"
            class="btn-inner"
            @click="dialog = true"
        >
          <v-icon class="mr-2">mdi-plus-box-multiple-outline</v-icon>
          Mass budget
        </v-btn>
      </div>

    </div>
    <div>
      <template>
          <v-dialog
              v-model="dialog"
              persistent
              max-width="600px"
          >
            <template v-slot:activator="{ on, attrs }">
            </template>
            <v-card class="mass-budget-card">
              <v-card-title class="pr-2">
                <div class="text-h5">Mass Budget Change</div>
                <div>
                  <v-btn
                      class="px-0"
                      @click="dialog = false"
                      fab
                      text
                  >
                    <v-icon large>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row style="flex-direction: column" justify="center" align="center">
                    <v-col class="update-budget-title pb-0" cols="6">
                      <label>Updating budget to</label>
                    </v-col>
                    <v-col class="update-budget-input pb-0" cols="6">
                      <div class="dollar-budget">$</div>
                      <v-text-field
                          dense
                          v-model="massBudgetAmount"
                          outlined
                          required
                          maxlength=6
                          :rules="[massUpValidation()]"
                          style="max-width: 60px"
                          class="budget-figure"
                      />
                    </v-col>
                    <v-col class="update-budget-domains-count pb-0" cols="6">
                      for <span class="primary-color"> {{ this.selected.length}} </span> domains
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions class="pb-4">
                <v-btn
                    dark
                    @click="massBudget"
                    class="apply-button"
                >
                  Apply
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </template>

    </div>
        <v-data-table
            :headers="table.headersVerticalGroup"
            :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
            :items="getVerticalGroup"
            :server-items-length="getVerticalGroup.length"
            :disable-sort="true"
            :loading="table.loading"
            :footer-props="{itemsPerPageOptions: table.pageOptions}"
            :page="table.currentPage"
            :items-per-page="table.perPage"
            :expanded.sync="expanded"
            show-expand
            show-select
            loading-text="Loading... Please wait"
            fixed-header
            :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
            item-class="td_title"
            color="#7F98A5"
            @input="onSelect"
            @pagination="updateTablePagination"
        >
          <template v-slot:top>
            <DataTableTopBar @search="search" />
          </template>

          <template v-for="item of table.headersVerticalGroup" :slot="`header.${[item.value]}`" slot-scope="{header}">
            <data-filter
                type="range"
                :min="table.filters[header.value].min"
                :max="table.filters[header.value].max"
                v-if="table.filters.hasOwnProperty(header.value)"
                :items="table.filters[header.value].data"
                :entity="header.value"
                :values="table.filters[header.value].selected"
                @apply="submitFilter"
            />
            <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
              <span class="header_title">{{header.text}}</span>
              <v-icon
                  size="16"
                  color="#7F98A5"
              >
                mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}
              </v-icon>
            </a>
            <span v-else class="header_title">{{header.text}}</span>
          </template>
          <template v-slot:item.data-table-select="{ item }">
            <v-checkbox
                v-if="ifCheckedVerticalsIndeterminate[item.verticalName]"
                indeterminate
                @change="checkAllDomainsInVertical(item)"
            />
            <v-checkbox
                v-else
                :value="checkedDomains[item.verticalName].length > 0 && (checkedDomains[item.verticalName].length === domainGroup[item.verticalName].length)"
                @change="checkAllDomainsInVertical(item)"
            />
          </template>
          <template #item.countOfDomains="{ item }">
            <span v-if="domainGroup[item.verticalName].length > 1 || !domainGroup[item.verticalName].length">{{ item.countOfDomains }} domains</span>
            <span v-else class="primary-color domain-name" @click="editDomain(domainGroup[item.verticalName][0])">
              {{ domainGroup[item.verticalName][0].domainName }}
            </span>
          </template>
          <template #item.countOfAdv="{ item }">
            <span v-if="domainGroup[item.verticalName].length > 1 || !domainGroup[item.verticalName].length">{{ item.countOfAdv }} advertisers</span>
            <span v-else class="primary-color advertiser-name" @click="showCard(domainGroup[item.verticalName][0])">
              {{ domainGroup[item.verticalName][0].advertiserName }}
            </span>
          </template>
          <template #item.budget="{ item }">
            <span v-if="domainGroup[item.verticalName].length > 1 || !domainGroup[item.verticalName].length">
              $ {{ new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(item.budget) }} / day
            </span>
            <span v-else>
              $ {{ new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(domainGroup[item.verticalName][0].budget) }} / day
            </span>
          </template>
          <template #item.countOfOffers="{ item }">
            <span
                v-if="domainGroup[item.verticalName].length > 1 || !domainGroup[item.verticalName].length"
                class="primary-color"
            >
              {{ item.countOfOffers }} offers
            </span>
            <span v-else class="primary-color">
              {{ domainGroup[item.verticalName].countOfOffers }} offers
            </span>
          </template>
          <template #item.last7DaysAvg="{ item }">
            <span
                :class="{'warning-color': !!table.isVerticalColumnRed[item.verticalName] && !!table.isVerticalColumnRed[item.verticalName].last7DaysAvg}"
                v-if="domainGroup[item.verticalName].length > 1 || !domainGroup[item.verticalName].length"
            >
              {{ item.last7DaysAvg }}
            </span>
            <span
                :class="{'warning-color': warningColor(domainGroup[item.verticalName], 'last7DaysAvg')}"
                v-else
            >
              {{ domainGroup[item.verticalName].last7DaysAvg }}
            </span>
          </template>
          <template #item.last30DaysAvg="{ item }">
            <span
                :class="{'warning-color': !!table.isVerticalColumnRed[item.verticalName] && !!table.isVerticalColumnRed[item.verticalName].last30DaysAvg}"
                v-if="domainGroup[item.verticalName].length > 1 || !domainGroup[item.verticalName].length"
            >
              {{ item.last30DaysAvg }}
            </span>
            <span
                :class="{'warning-color': warningColor(domainGroup[item.verticalName], 'last30DaysAvg')}"
                v-else
            >
              {{ domainGroup[item.verticalName].last30DaysAvg }}
            </span>
          </template>
          <template #item.ou7="{ item }">
            <span
                :class="{'warning-color': !!table.isVerticalColumnRed[item.verticalName] && !!table.isVerticalColumnRed[item.verticalName].ou7}"
                v-if="domainGroup[item.verticalName].length > 1 || !domainGroup[item.verticalName].length"
            >
              {{ item.ou7 || 0 }}%
            </span>
            <span
                :class="{'warning-color': warningColor(domainGroup[item.verticalName], 'ou7')}"
                v-else
            >
              {{ domainGroup[item.verticalName].ou7 || 0 }}%
            </span>
          </template>
          <template #item.ou30="{ item }">
            <span
                :class="{'warning-color': !!table.isVerticalColumnRed[item.verticalName] && !!table.isVerticalColumnRed[item.verticalName].ou30}"
                v-if="domainGroup[item.verticalName].length > 1 || !domainGroup[item.verticalName].length"
            >
              {{ item.ou30 || 0 }}%
            </span>
            <span
              v-else
            >
              {{ domainGroup[item.verticalName].ou30 || 0 }}%
            </span>
          </template>
          <template #item.status="{ item }">
            <span
                class="offer-status"
                v-if="item.status === 'active' && (domainGroup[item.verticalName].length > 1)"
            >
              <v-btn
                  small
                  dark
                  color='green'
                  class="status-button"
              >
                  ACTIVE
              </v-btn>
            </span>
            <span
                class="offer-status"
                v-else-if="item.status === 'inactive' && (domainGroup[item.verticalName].length > 1)"
            >
              <v-btn
                  small
                  dark
                  color="red"
                  class="status-button"
              >
                  INACTIVE
              </v-btn>
            </span>

            <span
                class="offer-status"
                v-else-if="item.status === 'mixed'"
            >
              <v-btn
                  small
                  dark
                  color="#CCCCCC"
                  class="status-button"
              >
                  MIXED
              </v-btn>
            </span>

            <span
                class="offer-status"
                v-else-if="domainGroup[item.verticalName].length === 1"
            >
              <v-btn
                  small
                  dark
                  :color="domainGroup[item.verticalName][0].status === 'active' ? 'green' : 'red'"
                  class="status-button"
              >
                {{ domainGroup[item.verticalName][0].status.toUpperCase() }}
              </v-btn>
            </span>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-0 ma-0">
                  <v-simple-table class="ma-0 pa-0 scrollable-expand">
                    <template v-slot:default>
                      <tbody>
                        <tr
                          v-for="(value, index) in domainGroup[item.verticalName]"
                          :key="index"
                        >
                          <td style="width: 90px"></td>
                          <td style="width: 50px">
                            <v-checkbox
                                :input-value="checkedDomains[item.verticalName].includes(index) > 0"
                                @change="domainChecked(index, item)"
                            />
                          </td>
                          <td class="spacer"></td>
                          <td style="width: 143px">
                            <span @click="editDomain(value)" class="domain-name">{{value.domainName}}</span>
                          </td>
                          <td style="width: 162px">
                            <span @click="showCard(value)" class="advertiser-name primary-color">{{value.advertiserName}}</span>
                          </td>
                          <td style="width: 139px">
                            <div class="budget-sub-row" v-if="user[0].can('edit_domains_budget')">
                              $
                              <v-text-field
                                  dense
                                  v-model="value.budget"
                                  @change="updDomainGroup(value)"
                                  outlined
                                  required
                                  maxlength=6
                                  :rules="[singleBudgetUpdateValidation]"
                                  :value="new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(value.budget)"
                                  style="max-width: 48px;height: fit-content;"
                                  class="budget-figure"
                              />
                              / day
                            </div>
                            <div v-else>
                              $ {{ new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(value.budget) }} / day
                            </div>
                          </td>
                          <td style="width: 131px">
                            <span class="primary-color offers-count" @click="showCard(value, 1)">
                              {{ value.countOfOffers }}
                              <span v-if="value.countOfOffers > 1">offers</span>
                              <span v-else>offer</span>
                            </span>
                          </td>
                          <td style="width: 140px">
                            <span :class="{'warning-color': warningColor(value, 'last7DaysAvg')}">{{ value.last7DaysAvg }}</span>
                          </td>
                          <td :class="{'warning-color': warningColor(value, 'ou7')}" style="width: 128px">{{ value.ou7 || 0 }}%</td>
                          <td :class="{'warning-color': warningColor(value, 'last30DaysAvg')}"  style="width: 249px">{{ value.last30DaysAvg }}</td>
                          <td :class="{'warning-color': warningColor(value, 'ou30')}"  style="width: 139px">{{ value.ou30 || 0 }}%</td>
                          <td style="width: 139px">
                            <span class="offer-status" v-if="value.status === 'active' ">
                              <v-btn
                                  small
                                  dark
                                  color='green'
                                  class="status-button"
                              >
                                  ACTIVE
                              </v-btn>
                            </span>

                            <span class="offer-status" v-else-if="value.status === 'inactive'">
                              <v-btn
                                  small
                                  dark
                                  color="red"
                                  class="status-button"
                              >
                                  INACTIVE
                              </v-btn>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
              </td>
          </template>
        </v-data-table>
    <div class="loader-wrapper" v-if="loading">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>

    <DomainsBudgetImport v-model="domainsBudgetImport"></DomainsBudgetImport>
  </div>
</template>

<script>
import MainLayout from "../../layouts/MainLayout"
import DataTableTopBar from '@/components/common/DataTableTopBar';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import store from '../../../store'
import api from "../../../api/domains";
import DomainsBudgetImport from "@/components/pages/advertisers/DomainsBudgetImport.vue";

export default {
  name: 'Domains',
  data() {
    return {
      domainsBudgetImport: false,
      detailTab: {},
      dialog: false,
      massBudgetAmount: 0,
      singleSelect: false,
      selected: [],
      expanded: [],
      sheet: false,
      budgetEdit: [],
      loading: false,
      domainGroup: {},
      checkedDomains: {},
      ifCheckedVerticalsIndeterminate: {},
      table: {
        search: '',
        heightCounter: 45,
        loading: false,
        searchInAffiliates: '',
        awaitingSearch: false,
        currentPage: 1,
        perPage: 25,
        pageOptions: [10, 25, 50, 100],
        orderBy: '',
        sortColumnsAsc: true,
        isVerticalColumnRed: {},
        headersVerticalGroup: [
          {text: 'Vertical', value: 'verticalName', align: 'center' , width: '180px'},
          {text: 'Domain', value: 'countOfDomains', align: 'center' },
          {text: 'Advertiser', value: 'countOfAdv', align: 'center' },
          {text: 'Budget', value: 'budget', align: 'center'},
          {text: 'Offers', value: 'countOfOffers', align: 'center' },
          {text: 'Daily Avg. Last 7 days', value: 'last7DaysAvg', align: 'center' },
          {text: 'O/U 7', value: 'ou7', align: 'center' },
          {text: 'Daily Avg. Last 30 days', value: 'last30DaysAvg', align: 'center' },
          {text: 'O/U 30', value: 'ou30', align: 'center' },
          {text: 'Status', value: 'status', align: 'center'},
        ],
        headersDomainGroup: [
          {text: 'Domain', value: 'domainName', align: 'center' },
          {text: 'Advertiser', value: 'advertiserName', align: 'center' },
          {text: 'Budget', value: 'budget', align: 'center' },
          {text: 'Offers', value: 'countOfOffers', align: 'center' },
          {text: 'Daily Avg. Last 7 days', value: 'last7DaysAvg', align: 'center' },
          {text: 'O/U 7', value: 'ou7', align: 'center' },
          {text: 'Daily Avg. Last 30 days', value: 'last30DaysAvg', align: 'center' },
          {text: 'O/U 30', value: 'ou30', align: 'center' },
          {text: 'Status', value: 'status', align: 'center'},
        ],
        filters: {
          //verticalName: {selected: [], data: []},
          //countOfDomains: {selected: [], data: [], min: 0, max: 1},
          countOfAdv: {selected: [], data: [], min: 0, max: 1},
          budget: {selected: [], data: [], min: 0, max: 1},
          countOfOffers: {selected: [], data: [], min: 0, max: 1},
          last7DaysAvg: {selected: [], data: [], min: 0, max: 1},
          ou7: {selected: [], data: [], min: 0, max: 1},
          last30DaysAvg: {selected: [], data: [], min: 0, max: 1},
          ou30: {selected: [], data: [], min: 0, max: 1},
          //status: {selected: [], data: []},
        }
      }
    }
  },
  async created() {
    if (!this.user[0].can('see_domains_budget')){
      await this.$router.push('/403');
    }
  },
  async mounted() {
    await this.getGeneralData()
    await this.getFiltersData()
  },

  components: {
    DomainsBudgetImport,
    MainLayout,
    DataTableTopBar
  },
  watch: {
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('domains', [
      'getVerticalGroup','getDomainGroup','getDomainGroupOrigin','getDomainHistory'
    ]),
    ...mapGetters('advertiser', ['profiles']),
    domainsGroup() {
      this.getGeneralData()
      return
    }
  },
  methods: {
    async getFiltersData() {
      this.getVerticalGroup.forEach(value => {
        Object.keys(value).forEach(key => {
          if (this.table.filters[key]) {
            if (key === 'budget') {
              console.log(value[key])
            }
            this.table.filters[key].data.push({
              key: value[key],
              value: value[key]
            })
            this.table.filters[key].min = +value[key] < this.table.filters[key].min ? +value[key] : this.table.filters[key].min
            this.table.filters[key].max = +value[key] > this.table.filters[key].max ? +value[key] : this.table.filters[key].max
          }
        })
      })
    },
    async getFilters() {
      const filters = {};
      filters['search'] = (this.table.search.length > 0) ? this.table.search : '';
      for (const name in this.table.filters) {
        filters[name] = (this.table.filters[name].selected.length > 0)
            ? `${this.table.filters[name].selected.join(',')}`
            : null;
      }

      return filters;
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = column
      await this.getGeneralData()
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1
      if (data && entity) {
        this.table.filters[entity].selected = data
      }
      return await this.getGeneralData()
    },
    search(value) {
      this.table.search = value;
      this.submitFilter();
    },
    onSelect(event) {
      if (event.length === 0) {
        Object.keys(this.advInvoices).forEach(value => {
          this.checkedDomains[this.advInvoices[value].period] = []
        })
      } else if ((event.length === this.advInvoices.length) || (event.length === this.table.perPage)) {
        event.forEach(period => {
          this.checkedDomains[period.period] = []
          period.corps.forEach(corp => {
            this.checkedDomains[period.period].push(corp.corp_id)
          })
        })
      } else {
        Object.keys(this.checkedDomains).forEach(value => {
          this.checkedDomains[value] = []

          event.forEach(period => {
            if (value === period.period) {
              period.corps.forEach(corp => {
                this.checkedDomains[period.period].push(corp.corp_id)
              })
            }
          })
        })
      }
    },
    checkAllDomainsInVertical(data) {
      if (this.checkedDomains[data.verticalName].length === this.domainGroup[data.verticalName].length) {
        this.checkedDomains[data.verticalName] = []

        this.fillInSelectedDomains()

        this.$forceUpdate()
        return
      }

      this.domainGroup[data.verticalName].forEach((value, index) => {
        this.checkedDomains[data.verticalName].push(index);
      })

      this.fillInSelectedDomains()

      this.$forceUpdate()
    },
    ifIndeterminate(item) {
      if (0 < this.checkedDomains[item.verticalName].length && this.checkedDomains[item.verticalName].length < this.domainGroup[[item.verticalName]].length) {
        this.ifCheckedVerticalsIndeterminate[item.verticalName] = true
        this.$forceUpdate()
        return
      }
      this.ifCheckedVerticalsIndeterminate[item.verticalName] = false
      this.$forceUpdate()
    },
    domainChecked(data, item) {
      if (
          this.checkedDomains[item.verticalName].length > 0
          && this.checkedDomains[item.verticalName].indexOf(data) >= 0
      ) {
        const index = this.checkedDomains[item.verticalName].indexOf(data)
        this.checkedDomains[item.verticalName].splice(index, 1)

        this.fillInSelectedDomains()

        return this.ifIndeterminate(item)
      }
      this.checkedDomains[item.verticalName].push(data);

      this.fillInSelectedDomains()

      this.ifIndeterminate(item)
    },
    fillInSelectedDomains() {
      const selectedItems = []
      Object.keys(this.checkedDomains).forEach(vertical => {
        this.checkedDomains[vertical].forEach(index => selectedItems.push(this.domainGroup[vertical][index]))
      })

      this.selected = selectedItems
    },
    warningColor(item, field) {
      if (
          field === 'last7DaysAvg' && item[field] > item.budget
          || field === 'last30DaysAvg' && item[field] > item.budget
      ) {
        return true
      } else if (
          field === 'ou7' && item[field] > 100
          || field === 'ou30' && item[field] > 100
      ) {
        return true
      }
    },
    verticalWarningColor(item, fields) {
      for (const field of fields) {
        if (
            field === 'last7DaysAvg' && item[field] > item.budget
            || field === 'last30DaysAvg' && item[field] > item.budget
        ) {
          if (!this.table.isVerticalColumnRed[item.verticalName]) {
            this.table.isVerticalColumnRed[item.verticalName] = {}
          }
          if (!this.table.isVerticalColumnRed[item.verticalName][field]) {
            this.table.isVerticalColumnRed[item.verticalName][field] = true
          }
        } else if (
            field === 'ou7' && item[field] > 100
            || field === 'ou30' && item[field] > 100
        ) {
          if (!this.table.isVerticalColumnRed[item.verticalName]) {
            this.table.isVerticalColumnRed[item.verticalName] = {}
          }
          if (!this.table.isVerticalColumnRed[item.verticalName][field]) {
            this.table.isVerticalColumnRed[item.verticalName][field] = true
          }
        }
      }
    },
    massUpValidation() {
      if (isNaN(Number(this.massBudgetAmount))) {
        return 'Allow Only number'
      }
      if (this.massBudgetAmount.length >= 5) {
        return 'Max 5 characters'
      }
      return !!this.massBudgetAmount || 'This field is required'
    },
    singleBudgetUpdateValidation(data) {
      if (isNaN(Number(data))) {
        return 'Allow Only number'
      }
      if (data.length >= 5) {
        return 'Max 5 characters'
      }
      return !!data || 'This field is required'
    },
    async massBudget() {
      if (isNaN(Number(this.massBudgetAmount))) {
        return
      }
      if (!this.massBudgetAmount) {
        this.massBudgetAmount = null
        return
      }
      const massBudgetAmount = Number(this.massBudgetAmount)
      if (massBudgetAmount) {
        await this.saveBudget(massBudgetAmount)
      }

      this.dialog = false

      /*
        this.selected.forEach(selected => {
        this.domainGroup.forEach(i => {
          if (i.id === selected.id) {
            i.budget = massBudgetAmount
          }
        })
        })
      */
    },
    async saveBudget(massBudgetAmount) {
      const isMassBudget = typeof massBudgetAmount === 'number'
      const domainsBudget = isMassBudget ? this.selected : this.getDomainHistory
      const domainsBudgetSend = []
      domainsBudget.forEach(i => {
        domainsBudgetSend.push({
          id: i.id,
          budget: isMassBudget ? massBudgetAmount : i.budget
        })
      })
      const resDb = await store.dispatch('domains/updateDomainsBudget', domainsBudgetSend)
      if (resDb.success) {
        /*await this.$dialog.notify.success(`Updated ${resDb.count} records `, {
          position: 'top-right',
          timeout: 100
        })*/
        await this.commitChangesDomains()
        this.getGeneralData()
        this.getFiltersData()

      } else {
        await this.$dialog.notify.error(`Errors${resDb.error} records `, {
          position: 'top-right',
          timeout: 2000
        })
        this.rollbackChangesDomains()
      }
    },
    async updateSingleBudget(budget, id) {
      console.log(budget, id)
      const resDb = await store.dispatch('domains/updateDomainsBudget', [{
        id: id,
        budget: budget,
      }])
      if (resDb.success) {
        await this.$dialog.notify.success(`Updated ${resDb.count} records `, {
          position: 'top-right',
          timeout: 100
        })
        await this.commitChangesDomains()
        this.getGeneralData()
        this.getFiltersData()

      } else {
        await this.$dialog.notify.error(`Errors${resDb.error} records `, {
          position: 'top-right',
          timeout: 2000
        })
        this.rollbackChangesDomains()
      }
    },
    updateTablePagination(params) {
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage

      this.getGeneralData();
    },
    async cancelBudget() {
      this.rollbackChangesDomains()
      this.getDomainHistory.forEach(h => {
        this.domainGroup.forEach(i => {
          if (i.id === h.id) {
            i.budget = h.oldBudgetValue
          }
        })
      })
      this.commitChangesDomains()
    },
    close() {
    },
    editDomain(item) {
      this.$router.push(`/advertisers/domain/${item.id}`);
    },
    showCard(item, activeTab = 0) {
      const {
        advertiserId, advertiserName, advertiserEmail,
        advertiserStatus, advertiserMargin, advertiserManagerName,
        advertiserManagerId
      } = item
      const advItem = {
        id: advertiserId,
        name: advertiserName,
        email: advertiserEmail,
        status: advertiserStatus,
        margin: advertiserMargin,
        advertiserManager: advertiserManagerName,
        advertiserManagerId: advertiserManagerId,
        readOnly: true,
        activeTab: activeTab
      }
      store.dispatch('cards/ADD', {
        type: 'advertiser',
        title: advertiserName,
        key: `advertiser-${advertiserId}`,
        data: advItem
      })
    },
    loadDetails(item) {
      this.domainGroup[item.verticalName] = this.getDomainGroup.filter(i => {
        if (!this.table.isVerticalColumnRed[item.verticalName]) {
          this.verticalWarningColor(i, ['last7DaysAvg', 'last30DaysAvg', 'ou7', 'ou30'])
        }
        return i.verticalName === item.verticalName
      })
    },
    ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
    ...mapMutations('domains', ['updDomainGroup', 'commitChangesDomains', 'rollbackChangesDomains']),
    async getGeneralData() {
      this.table.loading = true;
      const filters = await this.getFilters()

      await store.dispatch('domains/saveVerticalGroupStore', {
        pagination: {
          limit: this.table.perPage,
          page: this.table.currentPage
        },
      })
      await store.dispatch('domains/saveDomainGroupStore', {
        sorting: {
          orderBy: this.table.orderBy,
          orderDirectionAsc: this.table.sortColumnsAsc
        },
        filters: filters || null
      })

      this.getVerticalGroup.forEach(value => {
        this.checkedDomains[value.verticalName] = []
        this.ifCheckedVerticalsIndeterminate[value.verticalName] = false
        this.loadDetails(value)
      })

      this.$forceUpdate()
      this.table.loading = false
    }
  }
}
</script>

<style lang="sass">
.scrollable-expand
  overflow-y: auto
  .v-data-table__wrapper
    height: auto !important
    tr
      td
        text-align: center
        .budget-sub-row
          display: flex
          justify-content: space-between
          align-items: center
          .v-text-field
            height: auto
            .v-input__control
              background-color: #E3EEF4
              .v-input__slot
                margin: 0 !important
                min-height: auto !important
                display: flex !important
                align-items: center !important
      .spacer
        width: 100px
        padding-right: 16px
        padding-left: 16px
.warning-color
  color: red !important
.primary-color
  color: var(--v-primary-base) !important
.marginLeft
  margin-left: 50px

.budget-figure
  align-items: center
  .v-input__control
    .v-input__slot
      padding: 0 4px !important
      .v-text-field__slot
        input
          text-align: center
    .v-text-field__details
      display: none

.domain-name,
.advertiser-name,
.offers-count
  cursor: pointer
  text-decoration: none
  .domain-name:hover
    color: var(--v-primary-base) !important

.status-button
  min-width: 96px !important

.mass-budget-card
  .v-card__title
    justify-content: space-between
    .text-h5
      font-weight: 600
      font-size: 32px
      color: #3A3852
  .v-card__text
    font-size: 16px
    font-weight: 700
    color: #000000 !important
    .update-budget-title,
    .update-budget-input
      display: flex
      justify-content: center
      align-items: center
      .dollar-budget
        font-weight: 500
        font-size: 18px
        letter-spacing: 10px
    .update-budget-domains-count
      text-align: center
      .primary-color
        font-weight: 700
  .v-card__actions
    justify-content: end
    .apply-button
      background-color: #ACC3CF !important
      min-width: 150px !important
</style>
